// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RouterProgress_wrap__1c6bP","bar":"RouterProgress_bar__2ep3R"};